import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import DeleteIcon from "@mui/icons-material/Delete";
import AddUserIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { toast } from "react-toastify";
import spinner from "../assign-prescriptions/images/spinner.gif";
import ListItemText from "@mui/material/ListItemText";
import { Divider, Grid, Switch } from "@mui/material";
import USER_ROLES from "../common/userroles";
import { withTranslation } from "react-i18next";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { frFR } from "@mui/material/locale";
import { enUS } from "@mui/material/locale";
import Select from "@mui/material/Select";
import ListOfUsersByGroup from './list-of-users'

const localeTheme = createTheme(
  {},
  localStorage.getItem("i18nextLng") === "en" ? enUS : frFR
);

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => (event) => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      sortId,
      t,
    } = this.props;
    const rows = [
      {
        id: "name",
        numeric: false,
        disablePadding: true,
        label: t("Home.StartConsultPopup.Name"),
        field: "name",
      },
      {
        id: "parentAccount.name",
        numeric: false,
        disablePadding: true,
        label: t("Report.inActive.AssociatedAccount"),
        field: "parentAccount.name",
      },
      {
        id: "type.type",
        numeric: false,
        disablePadding: true,
        label: t("Groups.Header.Type"),
        field: "type.type",
      },
      {
        id: "actions",
        numeric: false,
        disablePadding: false,
        label: t("Users.Actions"),
      },
    ];
    return (
      <TableHead sx={{ height: "56px" }}>
        <TableRow>
          <TableCell sx={{ padding: "0 12px" }}>
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
              sx={{
                "&.Mui-checked": { color: "#0ae" },
                "&.MuiCheckbox-indeterminate": { color: "#0ae" },
              }}
            />
          </TableCell>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={"none"}
                sortDirection={orderBy === row.id ? order : false}
                sx={{
                  color: "rgba(0, 0, 0, 0.54)",
                  fontSize: "0.75rem",
                  fontWeight: "500",
                }}
              >
                <Tooltip
                  title={t("Global.Label.Filter.Sort")}
                  placement={row.numeric ? "bottom-end" : "bottom-start"}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.field && sortId === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id, row.field)}
                    sx={{ ".MuiSvgIcon-root": { fontSize: 16 } }}
                  >
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.mode === "light"
      ? {
          color: "#4fc3f7",
          backgroundColor: "rgb(255, 234, 231)",
        }
      : {
          color: "#4fc3f7",
          backgroundColor: "rgb(255, 234, 231)",
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
  add: {
    backgroundColor: "#00a7e1",
    color: "#fff",
    transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    "&:hover": {
      backgroundColor: "#6cca98",
      color: "#fff",
    },
  },
  gridActions: {
    display: "inline-block",
    width: "144px",
  },
});

const ITEM_HEIGHT = 48;

let EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    classes,
    add,
    confirmDelete,
    uadd,
    udelete,
    handleSearchChange,
    searchtxt,
    t,
  } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="" variant="subheading">
            {numSelected} {t("Users.SelectedRowsCount")}
          </Typography>
        ) : (
          <div>
            <TextField
              label={t("Users.Search")}
              onChange={handleSearchChange}
              value={searchtxt}
              fullWidth
              inputProps={{
                autocomplete: "new-password",
                form: {
                  autocomplete: "off",
                },
              }}
              sx={{ width: "30ch" }}
              variant="standard"
            />
          </div>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected === 1 ? (
          <div>
            {udelete === true ? (
              <Tooltip
                key="single-delete"
                title={t("Roles.DeleteRolesTooltip")}
              >
                <IconButton
                  aria-label="Delete"
                  onClick={confirmDelete}
                  sx={() => ({
                    "&:hover": { backgroundColor: "#6cca98", color: "#fff" },
                  })}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            ) : (
              ""
            )}
          </div>
        ) : numSelected > 1 ? (
          udelete === true ? (
            <Tooltip key="multi-delete" title={t("Roles.DeleteRolesTooltip")}>
              <IconButton
                aria-label="Delete"
                onClick={confirmDelete}
                sx={() => ({
                  "&:hover": { backgroundColor: "#6cca98", color: "#fff" },
                })}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          ) : (
            ""
          )
        ) : uadd === true ? (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Tooltip key="single-add" title={t("Roles.AddRoleTooltip")}>
              <IconButton
                aria-label={t("Roles.AddRoleTooltip")}
                className={classes.add}
                onClick={add}
              >
                <AddUserIcon />
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          ""
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(
  withTranslation()(EnhancedTableToolbar)
);

const styles = (theme) => ({
  Paper: {
    minWidth: "985px",
  },
  root: {
    width: "100%",
  },
  table: {
    minWidth: "auto",
  },
  tableWrapper: {
    overflowX: "auto",
  },
  halfTextField: {
    marginRight: "20px",
  },
  dropbox: {
    width: "135px",
    height: "105px",
    float: "right",
    textAlign: "center",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    overflow: "hidden",
    top: "56px",
    right: "2px",
    position: "relative",
  },
  innerBox: {
    margin: "0 auto",
    display: "block",
    height: "100%",
  },
  dropImage: {
    width: "80%",
    height: "100%",
  },
  dropPic: {
    width: "100%",
    height: "100%",
  },
  errorDiv: {
    paddingTop: "10px",
    color: "red",
  },
  captionText: {
    lineHeight: "1",
    color: "#8a8a8a",
    fontSize: "13px",
    textAlign: "center",
  },
  twoChildren: {
    display: "flex",
    justifyContent: "space-between",
  },
  leftChild: {},
  rightChild: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  spinner: {
    position: "absolute",
    background: "rgba(255,255,255,.4)",
    width: "100%",
    height: "100%",
    zIndex: "9999",
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: "calc(50% - 32.5px)",
    left: "calc(50% - 65px)",
    position: "absolute",
    width: "130px",
    userSelect: "none",
  },
  hidden: {
    display: "none",
  },
  formControl: {
    margin: "5px",
    minWidth: "100%",
  },
  boxDesign: {
    alignItems: "center",
    justifyContent: "center",
  },
  primaryButton: {
    background: "#6cca98",
    color: "#fff",
    "&:hover": {
      background: "#6cca98",
      color: "#fff",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.38)",
      cursor: "not-allowed",
      background: "#E4E5E8",
    },
  },
  dialogTitle: {
    fontSize: "1.3125rem",
    fontWeight: 500,
    lineHeight: "1.16667em",
  },
  menuItem: {
    paddingTop: "10px",
    paddingBottom: "10px",
  },
});

let FilterObj = {
  searchtext: "",
  pageNo: 0,
  pageSize: 10,
  sortOrder: "desc",
  sortColumn: "created_on",
  tableName: "groups",
  parent_account_id: sessionStorage.getItem("parentAccountId"),
};

class GroupManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      orderBy: "created_on",
      selected: [],
      page: 0,
      rowsPerPage: 10,
      submitted: false,
      isButtonDisabled: false,
      userview: true,
      useradd: true,
      userdelete: true,
      useredit: true,
      searchtext: "",
      loader: false,
      isDisabled: false,
      innerLoader: false,
      rowID: null,
      isSuperAdmin: false,
      isAdmin: false,
      totalRecords: 0,
      locale: localStorage.getItem("i18nextLng") === "en" ? enLocale : frLocale,
      boxList: [],
      groupData: [],
      groupRowData: [],
      groupName: "",
      isActive: false,
      accountValues: [],
      parentId: "",
      groupType: [],
      groupTypeId: "",
      showGroupUsers: false,
      selectedGroupId: "",
      selectedGroupName: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({
      isSuperAdmin:
        sessionStorage.hasOwnProperty("superadmin") &&
        JSON.parse(sessionStorage.getItem("superadmin")) ===
          USER_ROLES.SUPERADMIN,
      isAdmin:
        sessionStorage.hasOwnProperty("admin") &&
        JSON.parse(sessionStorage.getItem("admin")) === USER_ROLES.ADMIN,
    });
    this.BindBoxes();
    this.getAccounts();
    this.getGroupTypes();
    this.setPermissions();
  }

  BindBoxes() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "groups/list", {
      method: "post",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(FilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((response) => {
        this.setState({ totalRecords: response.data.total });
        if (
          response &&
          response.data &&
          response.data.results &&
          response.data.results.length
        ) {
          this.setState({
            data: response.data.results,
            loader: false,
            isDataEmpty: false,
          });
        } else {
          this.setState({ data: null, loader: false, isDataEmpty: true });
        }
      });
  }

  gettingOnSortTableName = (field) => {
    let tablename = "";
    if (["name"].includes(field)) {
      tablename = "groups";
    }
    return tablename;
  };

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy, sortId: property });
    FilterObj.sortOrder = order;
    FilterObj.sortColumn = field;
    FilterObj.tableName = this.gettingOnSortTableName(orderBy);
    const { data } = this.state;
    if (data && data.length > 0) {
      this.BindBoxes();
    }
  };

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState((state) => ({ selected: state.data.map((n) => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { data } = this.state;
    FilterObj.pageNo = page;
    if (data && data.length > 0) {
      this.BindBoxes();
    }
  };

  handleChangeRowsPerPage = (event) => {
    const { data } = this.state;
    FilterObj.pageNo = 0;
    FilterObj.pageSize = event.target.value;
    if (data && data.length > 0) {
      this.BindBoxes();
    }
  };

  addUser = (event) => {
    this.setState({
      showNewUserDialog: true,
      operation: "Add",
      groupName: "",
    });
  };

  handleClose = (event) => {
    this.setState({ showNewUserDialog: false, user: {}, errorMessage: "" });
  };

  handleChange = (event) => {
    if (event.preventDefault) event.preventDefault();
    this.setState({ groupName: event.target.value });
  };

  handleView = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    this.setState({
      showNewUserDialog: true,
      operation: "View",
      rowID: selectedObject && selectedObject.id,
      groupName: selectedObject.name,
      selectedRowId: selectedObject && selectedObject.id,
      groupTypeId: selectedObject && selectedObject.type_id,
      parentId: selectedObject && selectedObject.parent_account_id,
      isActive: selectedObject && selectedObject.is_active,
    });
    this.handleContextClose(event);
  };

  handleEdit = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    this.setState({
      showNewUserDialog: true,
      operation: "Edit",
      groupName: selectedObject.name,
      selectedRowId: selectedObject && selectedObject.id,
      groupTypeId: selectedObject && selectedObject.type_id,
      parentId: selectedObject && selectedObject.parent_account_id,
      isActive: selectedObject && selectedObject.is_active,
      data: this.state && this.state.data,
    });
    this.handleContextClose(event);
  };

  confirmDelete = (event) => {
    // this.forDeletion
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => x.id === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => this.state.selected.indexOf(x.id) > -1
        ),
      });
    }
  };

  deleteConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
    }
  };

  deleteConfirmed = (event) => {
    this.setState({ deleteDialogOpen: false });
    this.handleDelete(event);
  };

  handleDelete = (event) => {
    event && event.preventDefault();
    const { selected, selectedRowId } = this.state;
    this.setState({ loader: true });
    let user = JSON.parse(sessionStorage.getItem("user")).username;
    let IdsToDelete = [];
    if ([undefined, "undefined", null, "null", ""].includes(selectedRowId)) {
      IdsToDelete.push(selected);
    } else {
      IdsToDelete.push(selectedRowId);
    }
    const result = fetch(
      `${process.env.REACT_APP_BASEURL}groups?id=${IdsToDelete.join(",").trim(",")}&userId=${user}`, {
        method: "DELETE",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result.then((_result) => {
      _result.json().then((res) => {
        this.setState({ loader: false });
        this.handleContextClose(event);
        this.BindBoxes();
        this.setState({
          isButtonDisabled: false,
          submitted: true,
          showNewUserDialog: false,
          errorMessage: "",
          searchtext: "",
          selectedRowId: "",
        });
        if ([200, "200"].includes(res && res.status)) {
          toast.success(
            this.props.t("Roles.Operation.RoleDeletedSuccessfully")
          );
        } else {
          toast.error(this.props.t("Roles.Operation.RoleDeletionFailed"));
        }
      });
    });
  };

  handleSearchChange = (event) => {
    let searchtxt = "";
    searchtxt = event.target.value;
    this.setState({ searchtext: event.target.value });
    FilterObj.sortOrder = "desc";
    FilterObj.sortColumn = "created_on";
    FilterObj.tableName = "";
    if (searchtxt.length >= 3) {
      FilterObj.searchtext = searchtxt;
      this.BindBoxes();
    } else if (searchtxt.length === 0) {
      FilterObj.searchtext = "";
      this.BindBoxes();
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { groupName, groupTypeId, parentId, isActive  } = this.state;
    let user = JSON.parse(sessionStorage.getItem("user")).username;
    this.setState({
      loader: true,
      isButtonDisabled: true,
    });
    var data = {
      name: groupName,
      type_id: groupTypeId,
      parent_account_id: parentId,
      user_id: user,
      is_active: isActive,
    };
    const result = fetch(process.env.REACT_APP_BASEURL + "groups", {
      method: "POST",
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    result
      .then((result) => {
        result.json().then((res) => {
          this.setState({ loader: false });
          if ([201, "201"].includes(res && res.status)) {
            toast.success(
              this.props.t("Grpup.Operation.GroupAddedSuccessfully")
            );
            FilterObj.searchtext = "";
            FilterObj.sortOrder = "desc";
            FilterObj.sortColumn = "created_on";
            FilterObj.tableName = "";
            this.BindBoxes();
            this.setState({
              isButtonDisabled: false,
              submitted: true,
              showNewUserDialog: false,
              errorMessage: "",
              searchtext: "",
              selectedRowId: "",
            });
          } else {
            toast.error(res && res.message);
            this.setState({
              isButtonDisabled: false,
              submitted: false,
            });
          }
        });
      })
      .catch((error) => {
        this.setState({ loader: false });
        this.setState({ errorMessage: error.message, isButtonDisabled: false });
      });
  };

  handleUpdate = (event) => {
    event.preventDefault();
    const { groupName, groupTypeId, parentId, isActive  } = this.state;
    let user = JSON.parse(sessionStorage.getItem("user")).username;
    this.setState({
      loader: true,
      isButtonDisabled: true,
    });
    var payload = {
      name: groupName,
      type_id: groupTypeId,
      parent_account_id: parentId,
      user_id: user,
      is_active: isActive,
    };
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    const result = fetch(
      process.env.REACT_APP_BASEURL + "groups?id=" + selectedObject.id,
      {
        method: "PUT",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );
    result
      .then((result) => {
        result.json().then((res) => {
          this.setState({ loader: false });
          if ([200, "200"].includes(res && res.status)) {
            toast.success(
              this.props.t("Roles.Operation.RoleUpdatedSuccessfully")
            );
            this.setState({
              isButtonDisabled: false,
              submitted: true,
              showNewUserDialog: false,
              searchtext: "",
              selectedRowId: "",
            });
            FilterObj.searchtext = "";
            FilterObj.sortOrder = "desc";
            FilterObj.sortColumn = "created_on";
            FilterObj.tableName = "";
            this.BindBoxes();
          } else {
            this.setState({
              isButtonDisabled: false,
              submitted: false,
            });
            toast.error(res && res.message);
          }
        });
      })
      .catch((error) => {
        this.setState({ loader: false });
        this.setState({ errorMessage: error.message });
      });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  handleContextClick = (event, n) => {
    event.preventDefault();
    this.setState({
      anchorEl: event.currentTarget,
      selectedRowId: n.id,
    });
  };

  handleContextClose = (event) => {
    event.preventDefault();
    this.setState({ anchorEl: null });
  };

  setPermissions = () => {
    let permissions = JSON.parse(sessionStorage.getItem("permissions"));
    let _checkUserRole = JSON.parse(sessionStorage.getItem("permissionUser"));
    if (_checkUserRole === USER_ROLES.SUPERADMIN) {
      this.setState({
        userview: true,
        useradd: true,
        useredit: true,
        userdelete: true,
      });
    } else {
      if (permissions && permissions.length > 0) {
        const _manageUsers = permissions.filter((item) => {
          return item.permission_entity_type === "Manage Groups";
        });
        if (_manageUsers.length > 0) {
          const isAdd = _manageUsers.filter(
            (x) => x.name.trim() === "Add" && x.is_allowed === 1
          );
          const isEdit = _manageUsers.filter(
            (x) => x.name.trim() === "Modify" && x.is_allowed === 1
          );
          const isView = _manageUsers.filter(
            (x) => x.name.trim() === "View" && x.is_allowed === 1
          );
          const isDelete = _manageUsers.filter(
            (x) => x.name.trim() === "Delete" && x.is_allowed === 1
          );
          // For Add
          if (isAdd.length > 0) {
            this.setState({ useradd: true });
          } else {
            this.setState({ useradd: false });
          }
          // For Edit
          if (isEdit.length > 0) {
            this.setState({ useredit: true });
          } else {
            this.setState({ useredit: false });
          }
          // For View
          if (isView.length > 0) {
            this.setState({ userview: true });
          } else {
            this.setState({ userview: false });
          }
          // For Delete
          if (isDelete.length > 0) {
            this.setState({ userdelete: true });
          } else {
            this.setState({ userdelete: false });
          }
        } else {
          this.setState({
            userview: false,
            useradd: false,
            useredit: false,
            userdelete: false,
          });
        }
      } else {
        this.setState({
          userview: false,
          useradd: false,
          useredit: false,
          userdelete: false,
        });
      }
    }
  };

  getAccounts = async () => {
    const result = fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: "GET",
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
    });
    result.then((result) => {
      result.json().then((res) => {
        const accountValues = res.map((account) => {
          return { value: account.id, label: account.name };
        });
        this.setState({ accountValues, parentId: accountValues[0] });
      });
    });
  };

  getGroupTypes = async () => {
    const result = fetch(process.env.REACT_APP_BASEURL + "groups/list/types", {
      method: "GET",
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
    });
    result.then((result) => {
      result.json().then((res) => {
        const groupTypeValues =
          res &&
          res.data &&
          res.data.map((gt) => {
            return { value: gt.id, label: gt.type };
          });
        this.setState({
          groupType: groupTypeValues,
          groupTypeId: groupTypeValues[0],
        });
      });
    });
  };

  handleChangeIsActive = () => {
    this.setState({ isActive: !this.state.isActive });
  };

  viewListOfUsers = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    this.setState({
      showGroupUsers: true,
      operation: "ViewUsers",
      selectedGroupId: selectedObject && selectedObject.id,
      selectedGroupName: selectedObject && selectedObject.name,
      selectedRowId: selectedObject && selectedObject.id,
    });
    this.handleContextClose(event);
  }

  closeUserDialog = () => {
    this.setState({
      showGroupUsers: false,
    });
  }

  render() {
    const { classes, t } = this.props;
    const {
      data,
      selected,
      anchorEl,
      totalRecords,
      groupType,
      groupTypeId,
      accountValues,
      isActive,
      parentId,
      selectedGroupId,
      selectedGroupName
    } = this.state;
    const contextOpen = Boolean(anchorEl);
    const readOnly = this.state.operation === "View";
    return (
      <div className={classes.root}>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt="loading" />
          </div>
        ) : null}
        <Dialog
          open={this.state.deleteDialogOpen || false}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("Users.AreYouSureDeleteText")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {t("Group.AreYouSureDeleteBodyText")} :
              <ul>
                {this.state.forDeletion &&
                  this.state.forDeletion.map(function(a) {
                    return <li>{a.name}</li>;
                  })}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.deleteConfirmClose}
              color="primary"
              className={classes.primaryButton}
            >
              {t("Users.AreYouSureDeleteCancelButton")}
            </Button>
            <Button
              onClick={this.deleteConfirmed}
              color="primary"
              autoFocus
              className={classes.primaryButton}
            >
              {t("Users.AreYouSureDeleteButton")}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          maxWidth="md"
          open={this.state.showNewUserDialog || false}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          classes={{ paper: classes.Paper }}
        >
          {this.state.loader ? (
            <div className={classes.spinner}>
              <img
                className={classes.spinnerImage}
                src={spinner}
                alt="loading"
              />
            </div>
          ) : null}
          <div className={classes.paddedBoxDivEdit}>
            <ValidatorForm
              ref="form"
              onSubmit={
                this.state.operation === "Add"
                  ? this.handleSubmit
                  : this.handleUpdate
              }
            >
              <DialogTitle id="form-dialog-title">
                {t(this.state.operation)} {t("Groups.Dialog.Title")}
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <span className={classes.errorDiv}>
                    {this.state.errorMessage}
                  </span>
                </DialogContentText>
                <Grid
                  container
                  rowSpacing={3}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  <Grid item xs={6} style={{ paddingTop: "17px" }}>
                    <TextValidator
                      autoFocus
                      margin="normal"
                      value={this.state && this.state.groupName}
                      id="groupName"
                      inputProps={{
                        readOnly: Boolean(readOnly),
                        maxLength: 50,
                        autocomplete: "off",
                      }}
                      label={t("Home.StartConsultPopup.Name")}
                      name="name"
                      type="name"
                      placeholder=""
                      style={{ width: "100%" }}
                      onChange={this.handleChange}
                      validators={["required"]}
                      errorMessages={[
                        t("Groups.Dialog.AddEditGroupNameValidation"),
                      ]}
                      variant="standard"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    {t("Groups.Dialog.AddEditGroupType")}
                    <Select
                      style={{ width: "100%" }}
                      value={groupTypeId || ""}
                      onChange={(e) =>
                        this.setState({
                          groupTypeId: e && e.target && e.target.value,
                        })
                      }
                      readOnly={this.state.operation === "View"}
                      inputProps={{
                        name: "groupType",
                        id: "groupType",
                      }}
                      variant="standard"
                    >
                      {groupType.map((type, index) => (
                        <MenuItem
                          key={index}
                          value={type && type.value}
                          selected
                        >
                          {type && type.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={6}>
                    {t("Location.ParentAccount")}
                    <Select
                      style={{ width: "100%" }}
                      value={parentId || ""}
                      onChange={(e) =>
                        this.setState({
                          parentId: e && e.target && e.target.value,
                        })
                      }
                      readOnly={this.state.operation === "View"}
                      inputProps={{
                        name: "parenetAccountId",
                        id: "parenetAccountId",
                      }}
                      variant="standard"
                    >
                      {accountValues.map((type, index) => (
                        <MenuItem
                          key={index}
                          value={type && type.value}
                          selected
                        >
                          {type && type.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={6} style={{ marginTop: "20px" }}>
                    {t("Groups.Dialog.IsActiveFlag")}
                    <Switch
                      classes={{
                        switchBase: classes.iOSSwitchBase,
                        bar: classes.iOSBar,
                        icon: classes.iOSIcon,
                        iconChecked: classes.iOSIconChecked,
                        checked: classes.iOSChecked,
                      }}
                      disableRipple
                      checked={isActive}
                      onChange={this.handleChangeIsActive}
                      value={isActive}
                      color="primary"
                      disabled={this.state.operation === "View"}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <div style={{ bottom: "0", width: "100%" }}>
                <DialogActions sx={{ padding: "15px 12px 9px 4px" }}>
                  <Button
                    onClick={this.handleClose}
                    color="primary"
                    className={classes.primaryButton}
                  >
                    {this.state.operation === "View"
                      ? t("Users.CloseButton")
                      : t("Users.CancelButton")}
                  </Button>
                  {this.state.operation !== "View" && (
                    <Button
                      type="submit"
                      disabled={this.state.isButtonDisabled}
                      color="primary"
                      className={classes.primaryButton}
                    >
                      {this.state.operation === "Edit"
                        ? t("Group.Action.Button.Update")
                        : t("Group.Action.Button.Add")}
                    </Button>
                  )}
                </DialogActions>
              </div>
            </ValidatorForm>
          </div>
        </Dialog>
        <EnhancedTableToolbar
          numSelected={selected.length}
          add={this.addUser}
          deleteUsers={this.deleteUsers}
          editUser={this.editUser}
          confirmDelete={this.confirmDelete}
          uadd={this.state.useradd}
          udelete={this.state.userdelete}
          handleSearchChange={this.handleSearchChange}
          searchtxt={this.state.searchtext}
        />
        <div className={classes.tableWrapper}>
          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            open={contextOpen}
            onClose={this.handleContextClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                // width: 200,
              },
            }}
          >
            {this.state.userview === true && (
              <MenuItem
                key="view"
                onClick={this.handleView}
                sx={{ height: "40px" }}
              >
                <ListItemText>{t("Users.ViewActions")}</ListItemText>
              </MenuItem>
            )}
            {this.state.useredit === true && (
              <MenuItem
                key="edit"
                onClick={this.handleEdit}
                sx={{ height: "40px" }}
              >
                <ListItemText>{t("Users.EditActions")}</ListItemText>
              </MenuItem>
            )}
            {this.state.userdelete === true && (
              <MenuItem
                disabled={this.state.isDisabled === true}
                key="delete"
                onClick={this.confirmDelete}
                sx={{ height: "40px" }}
              >
                <ListItemText>{t("Users.DeleteActions")}</ListItemText>
              </MenuItem>
            )}
            <MenuItem
                disabled={this.state.isDisabled === true}
                key="viewListOfUsers"
                onClick={this.viewListOfUsers}
                sx={{ height: "40px" }}
              >
                <ListItemText>{t("Groups.Users.Menu.ListUser")}</ListItemText>
              </MenuItem>
          </Menu>
          <Divider
            style={{
              marginTop: "10px",
              height: "5px",
              borderColor: "rgba(0, 0, 0, 0.12)",
              borderStyle: "solid",
              borderBottomWidth: "5px",
            }}
          />
          <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead
              numSelected={selected.length}
              order={FilterObj.sortOrder}
              orderBy={FilterObj.sortColumn}
              onSelectAllClick={this.handleSelectAllClick}
              onRequestSort={this.handleRequestSort}
              rowCount={data ? data.length : 0}
              sortId={this.state.sortId}
            />
            <TableBody>
              {!data ? (
                <TableRow>
                  <TableCell
                    colSpan={20}
                    sx={{ textAlign: "center", padding: "10px 0px" }}
                  >
                    {this.state.isDataEmpty && t("Users.NoDataFound")}
                  </TableCell>
                </TableRow>
              ) : (
                data &&
                data.length > 0 &&
                stableSort(
                  data,
                  getSorting(FilterObj.sortOrder, FilterObj.sortColumn)
                ).map((n) => {
                  const isSelected = this.isSelected(n.id);
                  const sx = {
                    color: "rgba(0, 0, 0, 0.87)",
                    fontSize: "0.8125rem",
                    fontWeight: "400",
                  };
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isSelected}
                      tabIndex={-1}
                      key={n.id}
                      selected={isSelected}
                      sx={{ height: "50px" }}
                    >
                      <TableCell
                        padding="checkbox"
                        onClick={(event) => this.handleClick(event, n.id)}
                        sx={{ padding: "0 12px" }}
                      >
                        <Checkbox
                          checked={isSelected}
                          sx={{ "&.Mui-checked": { color: "#0ae" } }}
                        />
                      </TableCell>
                      <TableCell
                        padding={"none"}
                        onClick={(event) => this.handleClick(event, n.id)}
                        sx={{ ...sx }}
                        style={{ width: "30%" }}
                      >
                        {n.name}
                      </TableCell>
                      <TableCell
                        padding={"none"}
                        onClick={(event) => this.handleClick(event, n.id)}
                        sx={{ ...sx }}
                        style={{ width: "30%" }}
                      >
                        {n && n.parentAccount && n.parentAccount.name}
                      </TableCell>
                      <TableCell
                        padding={"none"}
                        onClick={(event) => this.handleClick(event, n.id)}
                        sx={{ ...sx }}
                        style={{ width: "30%" }}
                      >
                        {n && n.type && n.type.type}
                      </TableCell>
                      <TableCell padding={"none"}>
                        <IconButton
                          aria-label="More"
                          aria-owns={contextOpen ? "long-menu" : null}
                          aria-haspopup="true"
                          onClick={(event) => this.handleContextClick(event, n)}
                        >
                          <MoreVertIcon style={{ fontSize: 20 }} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </div>
        <ThemeProvider theme={localeTheme}>
          <TablePagination
            sx={{ ".MuiInputBase-root": { fontSize: "inherit" } }}
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalRecords || 0}
            rowsPerPage={FilterObj.pageSize}
            page={FilterObj.pageNo}
            backIconButtonProps={{
              "aria-label": "Previous Page",
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page",
            }}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </ThemeProvider>
        <Dialog
          maxWidth="md"
          open={this.state.showGroupUsers || false}
          aria-labelledby="form-dialog-title"
          classes={{ paper: classes.Paper }}
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("Groups.Users.Dialog.Title")} - {selectedGroupName}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <ListOfUsersByGroup selectedGroupId={selectedGroupId} />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.closeUserDialog}
              color="primary"
              className={classes.primaryButton}
            >
              {t("Vendors.CloseButton")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

GroupManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(GroupManagement));



// WEBPACK FOOTER //
// ./src/components/group-management/index.js